<template>
    <div class="public-client-commercial-address-step" data-cy="public-client-commercial-address-step">
        <div class="commercial-address-hero">
            <div class="commercial-address-hero__content">
                <span class="commercial-address-hero__eyebrow">Endereço comercial</span>
                <h4 class="commercial-address-hero__title">Informe onde o cliente trabalha ou atende comercialmente</h4>
                <p class="commercial-address-hero__text">
                    Esta etapa pode ser opcional, mas ajuda a manter os dados profissionais e comerciais completos.
                </p>
            </div>

            <div class="commercial-address-hero__status">
                <span class="commercial-address-hero__status-icon">
                    <i class="icon-domain"></i>
                </span>
                <small>Status</small>
                <strong>{{
                        commercialAddress.useResidentialAddress ? 'Usando residencial' : 'Endereço comercial'
                    }}</strong>
            </div>
        </div>

        <div class="commercial-toggle-card">
            <div class="commercial-toggle-card__content">
                <span><i class="icon-compare_arrows"></i></span>
                <div>
                    <strong>Usar o mesmo endereço residencial?</strong>
                    <small>Ative esta opção quando o endereço comercial for igual ao endereço principal do
                        cliente.</small>
                </div>
            </div>
            <label class="commercial-switch">
                <input v-model="commercialAddress.useResidentialAddress" @change="cloneAddressOnComercial"
                       type="checkbox"
                       data-cy="commercial-address-same-residential">
                <span></span>
            </label>
        </div>

        <transition name="commercial-address-fade" mode="out-in">
            <div v-if="commercialAddress.useResidentialAddress" key="same" class="commercial-empty-card">
                <span class="commercial-empty-card__icon"><i class="icon-check_circle"></i></span>
                <div>
                    <h5>Endereço residencial selecionado</h5>
                    <p>
                        O cadastro pode reaproveitar o endereço informado na etapa anterior como endereço comercial.
                    </p>
                </div>
            </div>

            <div v-else key="form">
                <div class="commercial-search-card">
                    <div class="commercial-search-card__field">
                        <div class="form-group mb-0">
                            <label for="commercial_client_cep"
                                   :class="{'required':requiredClassValidation('comercial_address_id', 'natural')}">CEP
                                comercial</label>
                            <div class="commercial-input">
                                <i class="icon-search commercial-input__icon"></i>
                                <input
                                        id="commercial_client_cep"
                                        v-model="commercialAddress.cep"
                                        type="text"
                                        inputmode="numeric"
                                        maxlength="9"
                                        class="form-control commercial-input__control"
                                        placeholder="00000-000"
                                        @change="loadCep(commercialAddress.cep)"
                                        data-cy="commercial-address-cep"
                                        @input="formatCep"
                                >
                            </div>
                            <div style="color: red" v-if="validate.cep"> {{ validate.cep }}</div>
                            <small class="form-text text-muted">
                                Busque pelo CEP ou preencha manualmente os campos comerciais.
                            </small>
                        </div>
                    </div>

                    <div class="commercial-search-card__actions">
                        <button type="button" class="btn btn-primary" data-cy="commercial-address-search">
                            <i class="icon-search"></i>
                            Buscar endereço
                        </button>
                    </div>
                </div>

                <div class="mb-3">
                    <div class="commercial-form-card">
                        <div class="commercial-form-card__header">
                            <div class="d-flex flex-row">
                                <span class="commercial-preview-card__icon">
                                    <i class="icon-business_center"></i>
                                </span>
                                <div class="ml-1">
                                    <span class="commercial-form-card__eyebrow">Dados comerciais</span>
                                    <h5>Endereço de trabalho</h5>
                                </div>
                            </div>
                            <span class="commercial-form-card__badge">Comercial</span>
                        </div>

                        <div class="row gutters">
                            <div class="col-lg-8 col-md-12">
                                <div class="form-group">
                                    <label for="commercial_street"
                                           :class="{'required':requiredClassValidation('comercial_address_id', 'natural') || commercialAddress.cep}">Logradouro</label>
                                    <input id="commercial_street" :disabled="!commercialAddress.cep"
                                           v-model="commercialAddress.street" type="text" class="form-control">
                                    <div style="color: red" v-if="validate.street"> {{ validate.street }}</div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group">
                                    <label for="commercial_number"
                                           :class="{'required':requiredClassValidation('comercial_address_id', 'natural') || commercialAddress.cep}">Numero</label>
                                    <input id="commercial_number" :disabled="!commercialAddress.cep"
                                           v-model="commercialAddress.number" type="text" class="form-control">
                                    <div style="color: red" v-if="validate.number"> {{ validate.number }}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="commercial_neighborhood"
                                           :class="{'required':requiredClassValidation('comercial_address_id', 'natural') || commercialAddress.cep}">Bairro</label>
                                    <input id="commercial_neighborhood" :disabled="!commercialAddress.cep"
                                           v-model="commercialAddress.neighborhood" type="text" class="form-control">
                                    <div style="color: red" v-if="validate.neighborhood"> {{ validate.neighborhood }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <label for="commercial_complement">Complemento</label>
                                    <input id="commercial_complement" :disabled="!commercialAddress.cep"
                                           v-model="commercialAddress.complement" type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-6">
                                <div class="form-group mb-lg-0">
                                    <label for="commercial_city"
                                           :class="{'required':requiredClassValidation('comercial_address_id', 'natural') || commercialAddress.cep}">Cidade</label>
                                    <input id="commercial_city" disabled v-model="commercialAddress.cityName"
                                           type="text" class="form-control">
                                    <div style="color: red" v-if="validate.cityName"> {{ validate.cityName }}</div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6">
                                <div class="form-group mb-lg-0">
                                    <label for="commercial_state"
                                           :class="{'required':requiredClassValidation('comercial_address_id', 'natural') || commercialAddress.cep}">UF</label>
                                    <input id="commercial_state" disabled v-model="commercialAddress.stateName"
                                           type="text" class="form-control" maxlength="2">
                                    <div style="color: red" v-if="validate.stateName"> {{ validate.stateName }}</div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12">
                                <div class="form-group mb-0">
                                    <label for="commercial_company_name">Empresa / local de trabalho</label>
                                    <input id="commercial_company_name" :disabled="!commercialAddress.cep"
                                           v-model="commercialAddress.company_name" type="text" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="commercial-extra-card">
                    <div class="commercial-extra-card__header">
                        <span><i class="icon-info"></i></span>
                        <div>
                            <strong>Referencia comercial</strong>
                            <small>Inclua detalhes uteis para contato, entrega ou conferencia dos dados.</small>
                        </div>
                    </div>

                    <textarea
                            v-model="commercialAddress.reference"
                            class="form-control"
                            rows="3" :disabled="!commercialAddress.cep"
                            placeholder="Ex.: sala, andar, recepcao, horario de atendimento..."
                    ></textarea>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import City from '../../../services/City';
import {mapMutations, mapState} from 'vuex';
import AttributesValidationsMixin from '../../../mixins/AttributesValidationsMixin';

export default {
    name: "createPublicStepComercialAddress",
    mixins: [AttributesValidationsMixin],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed: {
        ...mapState({
            commercialAddress: (state) => state.publicClient.commercialAddress,
            address: (state) => state.publicClient.address,
            attrsPhisical: (state) => state.publicClient.attrsPhisical,
            attrsJuridical: (state) => state.publicClient.attrsJuridical,
        })
    },
    data() {
        return {
            validate: {},
            fieldsValidate: ['cep', 'street', 'number', 'neighborhood', 'cityName', 'stateName'],
        }
    },
    methods: {
        ...mapMutations({setCommercialAddressPublicClientMutation: 'setCommercialAddressPublicClientMutation'}),
        cloneAddressOnComercial() {
            this.validate = {};
            if (this.commercialAddress.useResidentialAddress) {
                let data = this.address;
                data.useResidentialAddress = this.commercialAddress.useResidentialAddress;
                this.setCommercialAddressPublicClientMutation(data);
            } else {
                this.setCommercialAddressPublicClientMutation({});
            }
        },
        formatCep() {
            const digits = String(this.commercialAddress.cep || '').replace(/\D/g, '').slice(0, 8);
            this.commercialAddress.cep = digits.replace(/^(\d{5})(\d)/, '$1-$2');
        },
        loadCep(cep) {
            if (!cep) {
                this.setCommercialAddressPublicClientMutation({});
                this.commercialAddress = {};
                this.validate = {};
                return
            }
            this.$store.commit("changeLoading", true);
            City.listByCepDisp(cep).then(resp => {
                if (!resp.data.erro && resp.data?.id) {
                    this.commercialAddress.city_id = resp.data.id;
                    this.commercialAddress.stateName = resp.data.name;
                    this.commercialAddress.street = resp.data.logradouro;
                    this.commercialAddress.neighborhood = resp.data.bairro;
                    this.commercialAddress.cityName = resp.data.localidade;
                    this.commercialAddress.complement = resp.data.complemento;
                } else {
                    this.toast.error('Cep Inválido');
                    this.commercialAddress.cep = null;
                }
                this.$store.commit("changeLoading", false);
            }).catch(() => {
                this.toast.error('Cep Inválido');
                this.commercialAddress.cep = null;
                this.commercialAddress = {};
                this.$store.commit("changeLoading", false);
                this.msgCep = this.t('GENERAL.MSG.CEP_INVALID');
            });
        },
        validateAddress() {
            if (!this.commercialAddress.cep && !this.requiredClassValidation('comercial_address_id', 'natural')) {
                this.setCommercialAddressPublicClientMutation({});
                this.commercialAddress = {};
                return true;
            }
            this.fieldsValidate.forEach(i => {
                this.setVerifyInformedField(i);
            })
            let can_continue = true;
            Object.entries(this.validate).forEach(([index]) => {
                if (this.validate[index]) {
                    can_continue = false;
                }
            })
            this.setCommercialAddressPublicClientMutation(this.commercialAddress);
            return can_continue;
        },
        setVerifyInformedField(index) {
            if (!this.commercialAddress[index]) {
                this.validate[index] = 'Campo Obrigatório';
            } else {
                this.validate[index] = null;
            }
        },
    },
}
</script>

<style scoped>
.public-client-commercial-address-step {
    color: #243b35;
}

.commercial-address-hero {
    align-items: stretch;
    background: linear-gradient(135deg, #0e5e4e 0%, #16886f 54%, #f2fbf8 54%, #ffffff 100%);
    border-radius: 22px;
    box-shadow: 0 18px 44px rgba(14, 94, 78, .16);
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 16px;
    overflow: hidden;
    padding: 28px;
}

.commercial-address-hero__content {
    max-width: 640px;
    position: relative;
    z-index: 1;
}

.commercial-address-hero__eyebrow,
.commercial-form-card__eyebrow {
    color: #55d5b6;
    display: inline-block;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .12em;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.commercial-address-hero__title {
    color: #ffffff;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 10px;
}

.commercial-address-hero__text {
    color: rgba(255, 255, 255, .86);
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
}

.commercial-address-hero__status,
.commercial-toggle-card,
.commercial-empty-card,
.commercial-search-card,
.commercial-form-card,
.commercial-preview-card,
.commercial-extra-card {
    background: #ffffff;
    border: 1px solid #e4eee9;
    border-radius: 20px;
    box-shadow: 0 16px 36px rgba(21, 56, 48, .08);
}

.commercial-address-hero__status {
    align-items: flex-start;
    align-self: center;
    background: rgba(255, 255, 255, .92);
    border-color: rgba(255, 255, 255, .7);
    display: flex;
    flex-direction: column;
    min-width: 220px;
    padding: 18px;
}

.commercial-address-hero__status-icon,
.commercial-toggle-card__content span,
.commercial-empty-card__icon,
.commercial-preview-card__icon,
.commercial-extra-card__header span {
    align-items: center;
    background: #e8faf5;
    border-radius: 14px;
    color: #0e5e4e;
    display: flex;
    font-size: 22px;
    height: 46px;
    justify-content: center;
    width: 46px;
}

.commercial-address-hero__status-icon {
    margin-bottom: 12px;
}

.commercial-address-hero__status small,
.commercial-preview-card small {
    color: #7a8c87;
    font-weight: 700;
    margin-bottom: 4px;
}

.commercial-address-hero__status strong {
    color: #173b33;
    font-size: 16px;
}

.commercial-toggle-card {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 18px 20px;
}

.commercial-toggle-card__content {
    align-items: center;
    display: flex;
    gap: 12px;
}

.commercial-toggle-card__content strong {
    color: #173b33;
    display: block;
    font-weight: 800;
    margin-bottom: 2px;
}

.commercial-toggle-card__content small {
    color: #71857f;
}

.commercial-switch {
    margin: 0;
}

.commercial-switch input {
    display: none;
}

.commercial-switch span {
    background: #d9e8e3;
    border-radius: 999px;
    cursor: pointer;
    display: block;
    height: 30px;
    position: relative;
    transition: background .2s ease;
    width: 54px;
}

.commercial-switch span:before {
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(24, 52, 45, .18);
    content: '';
    height: 24px;
    left: 3px;
    position: absolute;
    top: 3px;
    transition: transform .2s ease;
    width: 24px;
}

.commercial-switch input:checked + span {
    background: #16886f;
}

.commercial-switch input:checked + span:before {
    transform: translateX(24px);
}

.commercial-empty-card {
    align-items: center;
    display: flex;
    gap: 18px;
    padding: 24px;
}

.commercial-empty-card h5,
.commercial-form-card h5,
.commercial-preview-card h5 {
    color: #173b33;
    font-weight: 800;
    margin-bottom: 4px;
}

.commercial-empty-card p,
.commercial-preview-card p {
    color: #71857f;
    margin-bottom: 6px;
}

.commercial-search-card {
    align-items: flex-end;
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr) auto;
    margin-bottom: 16px;
    padding: 20px;
}

.commercial-input {
    position: relative;
}

.commercial-input__icon {
    color: #16886f;
    font-size: 18px;
    left: 17px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.commercial-input__control {
    border-color: #d9e8e3;
    border-radius: 15px;
    font-size: 18px;
    font-weight: 700;
    height: 56px;
    letter-spacing: .04em;
    padding-left: 48px;
}

.commercial-search-card__actions {
    display: flex;
    gap: 10px;
}

.commercial-search-card__actions .btn {
    border-radius: 12px;
    font-weight: 800;
    min-height: 44px;
}

.commercial-form-card,
.commercial-preview-card,
.commercial-extra-card {
    padding: 24px;
}

.commercial-form-card__header {
    align-items: center;
    border-bottom: 1px solid #e6efeb;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 18px;
}

.commercial-form-card__eyebrow {
    color: #16886f;
    margin-bottom: 6px;
}

.commercial-form-card__badge,
.commercial-preview-card__cep {
    background: #e9fbf6;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 800;
    padding: 8px 12px;
}

.commercial-form-card label,
.commercial-search-card label {
    color: #344f48;
    font-weight: 800;
}

.commercial-form-card .form-control,
.commercial-extra-card .form-control {
    border-color: #dce9e4;
    border-radius: 12px;
    min-height: 44px;
}

.commercial-input__control:focus,
.commercial-form-card .form-control:focus,
.commercial-extra-card .form-control:focus {
    border-color: #19a985;
    box-shadow: 0 0 0 .2rem rgba(25, 169, 133, .14);
}

.commercial-preview-card {
    align-self: start;
}

.commercial-preview-card__cep {
    display: inline-block;
    margin-top: 12px;
}

.commercial-extra-card__header {
    align-items: center;
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}

.commercial-extra-card__header span {
    flex: 0 0 44px;
    font-size: 20px;
    height: 44px;
    width: 44px;
}

.commercial-extra-card__header strong {
    color: #173b33;
    display: block;
    font-size: 15px;
    font-weight: 800;
    margin-bottom: 2px;
}

.commercial-extra-card__header small {
    color: #71857f;
    display: block;
    line-height: 1.4;
}

.commercial-address-fade-enter-active,
.commercial-address-fade-leave-active {
    transition: opacity .18s ease, transform .18s ease;
}

.commercial-address-fade-enter-from,
.commercial-address-fade-leave-to {
    opacity: 0;
    transform: translateY(8px);
}

html.dark-theme .public-client-commercial-address-step {
    color: var(--dark-text-soft);
}

html.dark-theme .commercial-address-hero {
    background: linear-gradient(135deg, #064e3b 0%, #0f766e 52%, var(--dark-surface-2) 52%, var(--dark-surface) 100%);
    box-shadow: var(--dark-shadow);
}

html.dark-theme .commercial-address-hero__status,
html.dark-theme .commercial-toggle-card,
html.dark-theme .commercial-empty-card,
html.dark-theme .commercial-search-card,
html.dark-theme .commercial-form-card,
html.dark-theme .commercial-preview-card,
html.dark-theme .commercial-extra-card {
    background: var(--dark-surface) !important;
    border-color: var(--dark-border) !important;
    box-shadow: var(--dark-shadow) !important;
}

html.dark-theme .commercial-address-hero__status {
    background: rgba(17, 24, 39, .92) !important;
}

html.dark-theme .commercial-address-hero__status-icon,
html.dark-theme .commercial-toggle-card__content span,
html.dark-theme .commercial-empty-card__icon,
html.dark-theme .commercial-preview-card__icon,
html.dark-theme .commercial-extra-card__header span {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .commercial-address-hero__status strong,
html.dark-theme .commercial-toggle-card__content strong,
html.dark-theme .commercial-empty-card h5,
html.dark-theme .commercial-form-card h5,
html.dark-theme .commercial-preview-card h5,
html.dark-theme .commercial-extra-card__header strong {
    color: var(--dark-text) !important;
}

html.dark-theme .commercial-address-hero__status small,
html.dark-theme .commercial-toggle-card__content small,
html.dark-theme .commercial-empty-card p,
html.dark-theme .commercial-preview-card small,
html.dark-theme .commercial-preview-card p,
html.dark-theme .commercial-extra-card__header small,
html.dark-theme .form-text,
html.dark-theme .text-muted {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .commercial-input__control,
html.dark-theme .commercial-form-card .form-control,
html.dark-theme .commercial-extra-card .form-control {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text-soft) !important;
}

html.dark-theme .commercial-form-card label,
html.dark-theme .commercial-search-card label {
    color: var(--dark-text-soft) !important;
}

html.dark-theme .commercial-input__control::placeholder,
html.dark-theme .commercial-form-card .form-control::placeholder,
html.dark-theme .commercial-extra-card .form-control::placeholder {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .commercial-form-card__badge,
html.dark-theme .commercial-preview-card__cep {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .commercial-switch span {
    background: var(--dark-surface-3) !important;
}

html.dark-theme .commercial-switch input:checked + span {
    background: var(--dark-primary) !important;
}

@media (max-width: 991.98px) {
    .commercial-address-hero {
        background: linear-gradient(160deg, #0e5e4e 0%, #16886f 100%);
        flex-direction: column;
    }

    .commercial-address-hero__status {
        align-self: stretch;
    }

    .commercial-search-card,
    .commercial-address-grid {
        grid-template-columns: 1fr;
    }

    .commercial-search-card__actions {
        flex-wrap: wrap;
    }
}

@media (max-width: 575.98px) {
    .public-client-commercial-address-step {
        margin-left: -6px;
        margin-right: -6px;
    }

    .commercial-address-hero,
    .commercial-toggle-card,
    .commercial-empty-card,
    .commercial-search-card,
    .commercial-form-card,
    .commercial-preview-card,
    .commercial-extra-card {
        border-radius: 16px;
        padding: 16px 12px;
    }

    .commercial-address-hero {
        gap: 14px;
        margin-bottom: 12px;
    }

    .commercial-address-hero__eyebrow,
    .commercial-form-card__eyebrow {
        font-size: 10px;
        margin-bottom: 8px;
    }

    .commercial-address-hero__title {
        font-size: 21px;
        line-height: 1.22;
        margin-bottom: 8px;
    }

    .commercial-address-hero__text {
        font-size: 13px;
        line-height: 1.45;
    }

    .commercial-address-hero__status {
        align-items: center;
        border-radius: 14px;
        display: grid;
        gap: 4px 10px;
        grid-template-columns: 40px minmax(0, 1fr);
        min-width: 0;
        padding: 12px;
    }

    .commercial-address-hero__status-icon {
        grid-row: span 2;
        height: 40px;
        margin-bottom: 0;
        width: 40px;
    }

    .commercial-address-hero__status small,
    .commercial-address-hero__status strong {
        margin-bottom: 0;
    }

    .commercial-toggle-card,
    .commercial-search-card,
    .commercial-address-grid {
        gap: 12px;
        margin-bottom: 12px;
    }

    .commercial-toggle-card__content {
        gap: 10px;
    }

    .commercial-toggle-card__content span,
    .commercial-empty-card__icon,
    .commercial-preview-card__icon,
    .commercial-extra-card__header span {
        height: 40px;
        width: 40px;
    }

    .commercial-input__control {
        font-size: 16px;
        height: 50px;
    }

    .commercial-toggle-card,
    .commercial-toggle-card__content,
    .commercial-empty-card,
    .commercial-form-card__header,
    .commercial-extra-card__header {
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
    }

    .commercial-form-card__header {
        margin-bottom: 14px;
        padding-bottom: 14px;
    }

    .commercial-form-card h5,
    .commercial-preview-card h5,
    .commercial-empty-card h5 {
        font-size: 17px;
    }

    .commercial-empty-card p,
    .commercial-preview-card p,
    .commercial-toggle-card__content small,
    .commercial-extra-card__header small {
        font-size: 13px;
        line-height: 1.45;
    }

    .commercial-form-card .row.gutters > [class*="col-"] {
        margin-bottom: 12px;
    }

    .commercial-form-card .form-group,
    .commercial-form-card .form-group.mb-lg-0,
    .commercial-form-card .form-group.mb-0 {
        margin-bottom: 0 !important;
    }

    .commercial-form-card label,
    .commercial-search-card label {
        font-size: 12px;
        margin-bottom: 6px;
    }

    .commercial-form-card .form-control,
    .commercial-extra-card .form-control {
        border-radius: 11px;
        min-height: 42px;
    }

    .commercial-preview-card__cep {
        margin-top: 6px;
        padding: 7px 10px;
    }

    .commercial-search-card__actions,
    .commercial-search-card__actions .btn {
        width: 100%;
    }
}

@media (max-width: 991.98px) {
    html.dark-theme .commercial-address-hero {
        background: linear-gradient(160deg, #064e3b 0%, var(--dark-surface-2) 100%) !important;
    }
}

</style>
